import { toast } from "sonner";

/**
 * Show a points-earned toast if the response includes points_earned.
 * Usage: awardPoints(response.data, "+{n} pts")
 */
export function awardPoints(data, template = "+{n} pts") {
  const n = data?.points_earned;
  if (n && n > 0) {
    toast.success(template.replace("{n}", n), { duration: 1800 });
  }
}
